module.exports = __webpack_public_path__ + "img/5.1bcebce5.png";